export default __webpack_public_path__ + "static/media/previous.eb56afb7.svg";